import { useState, useContext } from "react";
import { Button, Input, Table,Spinner } from "reactstrap";
import { AppContext } from './AppContext';
import { BiSolidFilePdf } from "react-icons/bi";

export const Informes = (props) => {
    const edoGlobal = useContext(AppContext);
    let [fecIni,setFecIni] = useState(new Date().yyyymmdd('-'));
    let [fecFin,setFecFin] = useState(new Date().yyyymmdd('-'));
    let [reporte, setReporte] = useState(0);
    let [carrera, setCarrera] = useState(0);
    let [profesor, setProfesor] = useState(0);
    let [bitacora, setBitacora] = useState([]);
    let [asistencias, setAsistencias] = useState([]);
    let [cargando, setCargando] = useState(false);

    async function cargarBitacora(){
        setCargando(true);
        let url = `${edoGlobal.urlws}/admin/bitacora?profesor=${profesor}&fecIni=${fecIni}&fecFin=${fecFin}&token=${edoGlobal.institucion}&profesor=${edoGlobal.usuario.Id}&token=${edoGlobal.usuario.Token}`;
        let resp = await fetch(url);
        const a = await resp.json();
        setBitacora(a);
        setCargando(false);
        setReporte(1);
    }
    async function cargarAsistencias(){
        setCargando(true);
        let url = `${edoGlobal.urlws}/admin/asistencias?carrera=${carrera}&profesor=${profesor}&fecIni=${fecIni}&fecFin=${fecFin}&token=${edoGlobal.institucion}&profesor=${edoGlobal.usuario.Id}&token=${edoGlobal.usuario.Token}`;
        let resp = await fetch(url);
        const a = await resp.json();
        setAsistencias(a);
        setCargando(false);
        setReporte(2);
    }
    function asistenciasPDF(){
        let url = `${edoGlobal.urlws}/admin/asistenciasPDF?carrera=${carrera}&profesor=${profesor}&fecIni=${fecIni}&fecFin=${fecFin}&token=${edoGlobal.institucion}&profesor=${edoGlobal.usuario.Id}&token=${edoGlobal.usuario.Token}`;
        window.open(url, '', '');    
    }
    function actividadesPDF(){
        let url = `${edoGlobal.urlws}/admin/avanceActividades?fecha=${fecIni}&materia=0&periodo=0&token=${edoGlobal.institucion}`;
        window.open(url, '', '');    
    }
    const estiloDatos = { display: reporte !== 0? 'none' : 'inline' };
    const estiloBitacora = { display: reporte !== 1 ? 'none' : 'inline' };
    const estiloAsistencias = { display: reporte !== 2 ? 'none' : 'inline' };
    return (
        <div>
            {cargando ?
                <div className="loader">
                    <Spinner animation="border" className='rojo' >&nbsp;</Spinner>
                </div>
                :
                null
            }
            <div style={estiloDatos}>
                <h4>Informes</h4>
                <table>
                    <tr style={{ verticalAlign: 'center' }}>
                        <td><span>Del</span></td>
                        <td><Input size="sm" type="date" value={fecIni} onChange={(e) => setFecIni(e.target.value)} /></td>
                        <td><span>&nbsp;&nbsp;al&nbsp;&nbsp;</span></td>
                        <td><Input size="sm" type="date" value={fecFin} onChange={(e) => setFecFin(e.target.value)} /></td>
                        <td><Button onClick={cargarBitacora} size="sm" color="secondary" outline>Bitacora de acceso</Button></td>
                        <td><Button onClick={cargarAsistencias} size="sm" color="secondary" outline>Registro de asistencias</Button></td>
                        <td><Button onClick={actividadesPDF} size="sm" color="secondary" outline>Avance de actividades</Button></td>
                    </tr>
                </table>
            </div>
            <div style={estiloBitacora}>
                <Button className='botonLince' size="sm" color="secondary" outline onClick={() => setReporte(0)}>Regresar</Button><br/><br/>
                <Table size="sm" hover striped>
                    <thead>
                        <tr>
                            <th style={{ width: 100 }}>Fecha</th>
                            <th>Nombre</th>
                            <th className="celdaCh">Inicio</th>
                            <th className="celdaCh">Fin</th>
                        </tr>
                    </thead>
                    <tbody>
                        {bitacora.map((o, i) => {
                            return (
                                <tr key={i}>
                                    <td>{o.Fecha}</td>
                                    <td>{o.Nombre}</td>
                                    <td>{o.HoraIni}</td>
                                    <td>{o.HoraFin}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                <Button className='botonLince' size="sm" color="secondary" outline onClick={() => setReporte(0)}>Regresar</Button><br/><br/>
            </div>
            <div style={estiloAsistencias}>
                <Button className='botonLince' color="secondary" outline onClick={() => setReporte(0)}>Regresar</Button>
                <span>&nbsp;&nbsp;&nbsp;</span>
                <Button color="secondary" outline onClick={asistenciasPDF}><BiSolidFilePdf color='maroon' size={20} title="generar PDF" />&nbsp;PDF</Button>
                <span>&nbsp;&nbsp;&nbsp;</span>
                <br/><br/>                
                <Table size="sm" hover striped>
                    <thead>
                        <tr>
                            <th style={{ width: 100 }}>Fecha</th>
                            <th>Grupo</th>
                            <th>Profesor</th>
                            <th>Asignatura</th>
                            <th className="celdaCh">A</th>
                            <th className="celdaCh">F</th>
                            <th className="celdaCh">R</th>
                            <th className="celdaCh">J</th>
                        </tr>
                    </thead>
                    <tbody>
                        {asistencias.map((o, i) => {
                            return (
                                <tr key={i}>
                                    <td>{o.Fec}</td>
                                    <td>{o.Gpo}</td>
                                    <td>{o.Prof}</td>
                                    <td>{o.Mat}</td>
                                    <td>{o.A}</td>
                                    <td>{o.F}</td>
                                    <td>{o.R}</td>
                                    <td>{o.J}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                <Button className='botonLince' size="sm" color="secondary" outline onClick={() => setReporte(0)}>Regresar</Button><br/><br/>
            </div>
        </div>
    )
}
